(function () {
    'use strict';

    angular
        .module('app')
        .factory('LastUpdatedService', LastUpdatedService);

    LastUpdatedService.$inject = ['$filter'];

    /**
     * @ngdoc service
     * @name LastUpdatedService
     * 
     * @description
     * Handles operations related to Last Updated.
     * In particular is the generation of Last Updated labels
     */
    function LastUpdatedService($filter) {
        var service = {
            getLabel: getLabel,
            getTaskLabel: getTaskLabel,
            getWorkflowInstanceLabel: getWorkflowInstanceLabel
        };

        return service;


        /**
         * Generates the Last Updated label for the supplied record
         *
         * @param {object} record - Record which will be used to generate the last updated label.
         *                          The "record" object properties:
         *                              {string} UpdatedByUserName
         *                              {date} UpdatedDate
         *
         * @returns {string} - Returns Last updated label, e.g. "Last updated by xyz at abc", where "xyz" is a user name and "abc" is a date/time.
         */
        function getLabel(record) {
            return generateLabel('Last updated', record);
        }

        /**
         * Generates the Last Updated label for the supplied task
         *
         * @param {object} record - Task which will be used to generate the last updated label.
         *                          The "record" object properties:
         *                              {string} UpdatedByUserName
         *                              {date} UpdatedDate
         *
         * @returns {string} - Returns Last updated label, e.g. "Last updated by xyz at abc", where "xyz" is a user name and "abc" is a date/time.
         *                     For a completed task the label would be "Completed by xyz at abc".
         */
        function getTaskLabel(task) {
            if (!_.isNil(task) && !_.isNil(task.data)) {
                var prefix = 'Last updated';

                if (task.data.Completed) {
                    prefix = 'Completed';
                }

                return generateLabel(prefix, task.data);
            } else {
                return '';
            }
        }

        /**
         * Generates the Last Updated label for the supplied workflow instance
         *
         * @param {object} record - Workflow instance which will be used to generate the last updated label.
         *                          The "record" object properties:
         *                              {string} UpdatedByUserName
         *                              {date} UpdatedDate
         *                              {string} Status
         *
         * @returns {string} - Returns Last updated label, e.g. "Status: completed. Last updated by xyz at abc", where "xyz" is a user name, "abc" is a date/time and 'completed' is the status.
         */
        function getWorkflowInstanceLabel(workflowInstance) {
            if (!_.isNil(workflowInstance)) {
                var prefix = 'Status: ' + workflowInstance.Status + ' | Last updated';

                return generateLabel(prefix, workflowInstance);
            } else {
                return '';
            }
        }

        /**
         * Generates a label for the supplied prefix and record
         * NB: A blank label will be returned unless the record has 'UpdatedDate' set
         *
         * @param {string} prefix - Will be appended to the label
         * @param {object} record - Record which will be used to generate the last updated label.
         *                          The "record" object properties:
         *                              {string} UpdatedByUserName
         *                              {date} UpdatedDate
         *
         * @returns {string} - Returns label, e.g. "Label prefix by xyz at abc", where "Label prefix" is the label prefix, "xyz" is a user name and "abc" is a date/time.
         */
        function generateLabel(prefix, record) {
            var label = '';

            if (!_.isNil(record) && !_.isNil(record.UpdatedDate)) {
                label = prefix;

                if (!_.isNil(record.UpdatedByUserName)) {
                    label += ' by ' + record.UpdatedByUserName;
                }

                if (!_.isNil(record.UpdatedDate)) {
                    label += ' at ' + $filter('date')(record.UpdatedDate, 'medium');
                }
            }

            return label;
        }
    }
})();
